const cnameValidator = (value) => {
  if (!value) return "validate.cname_empty";
  const regex = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/;
  return regex.test(value) ? true : "validate.cname_failed";
};

export { cnameValidator };
